import * as React from "react";
import type { SVGProps } from "react";
const SvgLayers02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m17.4 12.174 4.2 2.153-9.6 4.92-9.6-4.92 4.277-2.192M12 4.752l9.6 4.92-9.6 4.922-9.6-4.921z"
    />
  </svg>
);
export default SvgLayers02;
